module.exports = __webpack_public_path__ + "img/login.62cfd468.jpg";